import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

export const ErrorHandler: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {}, [dispatch]);

  return <></>;
};
